export default {
    estimates: state => state.estimates,
    drafts: state => state.drafts,
    activeEstimate: state => state.activeEstimate,
    manageEstimateDialog: state => state.manageEstimateDialog,
    deleteEstimateDialog: state => state.deleteEstimateDialog
}
